import { assignInlineVars } from "@vanilla-extract/dynamic";
import { cx } from "class-variance-authority";

import { rawPalette } from "../../styles/theme.css";

import * as theme from "./ActivityTimelineDivider.css";

export interface ActivityTimelineDividerProps {
    children?: React.ReactNode;
    /** Any CSS color for the rule and its label. */
    color?: string;
    lineStyle?: "solid" | "dashed";
    /**
     * `"crossing"` (default) lays the rule over the continuing rail. `"terminal"`
     * is a plain closing line of the same width — the rail ends above it, no
     * overlap.
     */
    variant?: "crossing" | "terminal";
    className?: string;
}

export function ActivityTimelineDivider({
    children,
    color = rawPalette.base.red[500],
    lineStyle = "solid",
    variant = "crossing",
    className,
}: ActivityTimelineDividerProps) {
    const crossing = variant === "crossing";

    return (
        <div
            className={cx(theme.root, className)}
            style={assignInlineVars({
                [theme.colorVar]: color,
            })}
        >
            <span className={theme.rail} aria-hidden>
                {crossing && <span className={theme.railLine} />}
            </span>

            <div className={cx(theme.bar, crossing && theme.barCrossing)}>
                <span className={theme.line[lineStyle]} aria-hidden />
                {children && <span className={theme.label}>{children}</span>}
                <span className={theme.line[lineStyle]} aria-hidden />
            </div>
        </div>
    );
}
